import { Box, Button, Card, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import RewardRegisterContract from '../../../AllContract/RewardRegisterContract'
import { useWeb3Context } from '../../../hooks/web3Context'

const RegisterContract = () => {
  const { address: account, web3 } = useWeb3Context()
  const [contractAddress, setContractAddress] = React.useState('')
  const [ownerAddress, setOwnerAddress] = React.useState('')
  const [btnDisable, setBtnDisable] = useState(false)

  const handleRegisterContract = async () => {
    console.log('handleRegisterContract')
    setBtnDisable(true)

    try {
      let contract = await RewardRegisterContract.registerContract(
        contractAddress,
        ownerAddress,
      )
      console.log('contract', contract)
      let waitForTx = await contract.wait()
      if (waitForTx) {
        toast.success('transaction success')
      }
      setBtnDisable(false)
    } catch (error) {
      console.log('error', error.error.data.message)
      if (error.error.data.message) {
        toast.error(error.error.data.message)
      } else {
        toast.error('Execution reverted')
      }
      setBtnDisable(false)
    }
    setBtnDisable(false)
  }

  return (
    <>
      <ToastContainer />

      <div
        className="stack_modal"
        style={{
          display: 'flex',
          justifyContent: 'center',
          padding: '8px',
          marginTop: '24px',
        }}
      >
        <Card className="section-card">
          <Box sx={{ flexGrow: 1, width: '100%' }}>
            <Typography className="header-text">Register Contract</Typography>
            <Grid container pt={1} px={2}>
              <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                <Typography>Contract address</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <TextField
                  fullWidth
                  size="small"
                  variant="filled"
                  value={contractAddress}
                  onChange={(e) => setContractAddress(e.target.value)}
                  hiddenLabel
                  placeholder="Enter Contract Address"
                />
              </Grid>
            </Grid>

            <Grid container pt={1} px={2}>
              <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                <Typography>Owner Address</Typography>
              </Grid>
              <Grid item xs={12} md={6} sx={{ display: 'flex' }}>
                <TextField
                  fullWidth
                  size="small"
                  variant="filled"
                  value={ownerAddress}
                  onChange={(e) => setOwnerAddress(e.target.value)}
                  hiddenLabel
                  placeholder="Enter Owner Address"
                />
              </Grid>
            </Grid>

            <Grid container pt={1} px={2}>
              <Grid
                xs={12}
                md={12}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                {btnDisable === true ? (
                  <Button
                    variant="contained"
                    disabled
                    onClick={handleRegisterContract}
                    size="large"
                    sx={{
                      mt: 1,
                    }}
                  >
                    Submit
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={handleRegisterContract}
                    size="large"
                    sx={{
                      mt: 1,
                    }}
                  >
                    Submit
                  </Button>
                )}
              </Grid>
            </Grid>
          </Box>
        </Card>
      </div>
    </>
  )
}

export default RegisterContract
